import React, { useState } from "react";
import { Input, Popover } from "antd";
import { HexColorPicker } from "react-colorful";

interface ColorPickerProps {
  value?: string;
  onChange?: (color: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

export default function ColorPicker({
  value = "#aabbcc",
  onChange,
  placeholder = "Select color",
  disabled = false,
}: ColorPickerProps): React.ReactElement {
  const [visible, setVisible] = useState(false);

  const handleColorChange = (newColor: string) => {
    onChange?.(newColor);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    handleColorChange(inputValue);
  };

  const colorPicker = <HexColorPicker color={value} onChange={handleColorChange} />;

  return (
    <Popover content={colorPicker} trigger="click" open={visible} onOpenChange={setVisible}>
      <Input
        value={value}
        onChange={handleInputChange}
        style={{
          backgroundColor: value,
          color: "#000",
          cursor: disabled ? "not-allowed" : "pointer",
          borderRadius: "8px",
        }}
        placeholder={placeholder}
        disabled={disabled}
      />
    </Popover>
  );
}
